export const defaultCenter: IMapCoordinate = {
  lat: 37.799648,
  long: -122.2876002,
};

export const defaultZoom = 12;

export const getBaseLayers = (config: IMapConfig): IMapLayer[] => {
  const layers = config ? config.layers : null;
  const baseLayers = layers ? layers.baseLayers : [];

  return baseLayers;
};

export const getAgencyBoundary = (config: IMapConfig): IMapLayer => {
  const layers = config ? config.layers : null;

  return layers ? layers.agencyBoundaryKml : null;
};

export const getKMLLayers = (config: IMapConfig): IMapLayer[] => {
  const layers = config ? config.layers : null;
  const kmlLayers = layers && layers.kmls ? layers.kmls.filter((layer) => layer.source === MapLayerSource.KML) : [];

  return kmlLayers ? kmlLayers : [];
};

export const getCenter = (config: IMapConfig): IMapCoordinate =>
  config && config.center
    ? {
        lat: config.center[0],
        long: config.center[1],
      }
    : {
        lat: defaultCenter.lat,
        long: defaultCenter.long,
      };

export const getZoom = (config: IMapConfig): number => (config ? config.zoomLevel : defaultZoom);

export const generateAddress = (address: string, city: string, state: string, zip: string) => {
  let modifiedAddress = '';
  modifiedAddress += address && address.trim() !== '' ? `${address}, ` : '';
  modifiedAddress += city && city.trim() !== '' ? `${city}, ` : '';
  modifiedAddress += state && state.trim() !== '' ? `${state} ` : '';
  modifiedAddress += zip && zip.toString().trim() !== '' ? `${zip}` : '';

  return modifiedAddress.trim();
};
